import { render, staticRenderFns } from "./SiteNotice.vue?vue&type=template&id=7ba321d4&scoped=true"
import script from "./SiteNotice.vue?vue&type=script&lang=js"
export * from "./SiteNotice.vue?vue&type=script&lang=js"
import style0 from "./SiteNotice.vue?vue&type=style&index=0&id=7ba321d4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ba321d4",
  null
  
)

export default component.exports